import { Alert, Box, Card, CardActionArea, CardContent, Chip, Divider, Grid2 as Grid, Typography, alpha, useTheme } from '@mui/material';
import { Phone as PhoneIcon, Email as EmailIcon, MergeType as MergeIcon } from '@mui/icons-material';

const matchTypeLabels = {
  phone_and_email: 'Telefone + Email',
  phone: 'Telefone',
  email: 'Email',
};

const matchTypeColors = {
  phone_and_email: 'error',
  phone: 'warning',
  email: 'info',
};

function PersonSide({ person }) {
  return (
    <Box sx={{ flex: 1, px: 2, py: 1 }}>
      <Typography variant="subtitle1" fontWeight="bold" noWrap>
        {person.name}
      </Typography>
      {person.phone && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
          <PhoneIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">{person.phone}</Typography>
        </Box>
      )}
      {person.email && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
          <EmailIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary" noWrap>{person.email}</Typography>
        </Box>
      )}
    </Box>
  );
}

export default function DuplicatesBanner({ duplicates = [], onCardClick }) {
  const theme = useTheme();

  if (!duplicates || duplicates.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info" icon={<MergeIcon />} sx={{ mb: 2 }}>
        Encontramos pessoas que podem estar duplicadas. Clique em um card para revisar e unificar.
      </Alert>

      <Grid container spacing={2}>
        {duplicates.map((pair, index) => (
          <Grid key={index} size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                bgcolor: alpha(theme.palette.info.main, 0.06),
                border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                '&:hover': {
                  bgcolor: alpha(theme.palette.info.main, 0.12),
                  borderColor: theme.palette.info.main,
                },
                transition: 'all 0.2s',
              }}
            >
              <CardActionArea onClick={() => onCardClick(pair)}>
                <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                    <Chip
                      label={matchTypeLabels[pair.matchType] || pair.matchType}
                      color={matchTypeColors[pair.matchType] || 'default'}
                      size="small"
                      variant="outlined"
                    />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
                    <PersonSide person={pair.personA} />
                    <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                    <PersonSide person={pair.personB} />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
